
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	Month: null as number | null,
	Year: null as number | null,
	MonthYear: null as string | null,
	WorkshopId: [] as number [],
	WareHouseId : null as number |null,
	DateFrom: null as Date | null,
	DateTo: null as Date | null,
	AllItems: false as boolean | false,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [],
		WareHouseId:[],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
